import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { getVinWiseOpening, getVinWiseOpeningParams, getNotification, getFilteredVinWiseOpening } from '../data/selectors';
import { createVinWiseOpening, editVinWiseOpening, setNotifyDone } from '../data/actions';
import { vinWiseOpeningSchema } from '../data/model'
import { Header, Form, Button } from 'semantic-ui-react';
import { Formik, Field, Form as FormikForm } from 'formik';
import { FormikInputComponent } from '../../../utilities/formUtils';
import { setAlertModalState } from '../../common/data/actions';

import userACL from '../../../store/access'
import Notification from '../../../utilities/notificationUtils';

const VinWiseOpeningForm = (props) => {
    const vinWiseOpening = useSelector(state => getVinWiseOpening(state, props))
    const params = useSelector(state => getVinWiseOpeningParams(state, props))
    const vinWiseOpeningList = useSelector((state) => getFilteredVinWiseOpening(state));
    const [savedVinWiseOpeningId, setSavedVinWiseOpeningId] = useState(false)
    const dispatch = useDispatch()

    const saveVinWiseOpening = (values, resetForm) => {
        if (props.match.path === '/vin_wise_opp/create') {
            userACL.atCreate(values)
            dispatch(createVinWiseOpening(values))
            setSavedVinWiseOpeningId(values.vin)
        }
        if (props.match.path === '/vin_wise_opp/edit/:id') {
            userACL.atUpdate(values)
            dispatch(editVinWiseOpening(values))
            setSavedVinWiseOpeningId(values.vin)
            setTimeout(function () {
                props.history.push(`/vin_wise_opp/list`)
            }, 2000)
        }
    }

    // Function to check if VIN already exists
    const checkVinExists = (e, values, index, setFieldValue, fieldValue, fieldName, setFieldError) => {
        if (props.match.path === '/vin_wise_opp/create') { // Only check for create, not edit
            const existingVin = vinWiseOpeningList.find(item => item.vin.toLowerCase() === fieldValue.toLowerCase());
            if (existingVin) {
                dispatch(setAlertModalState({ isOpen: true, type: "error", size: "mini", title: "Warning", msg: "VIN already exists" }));
                setFieldValue(fieldName, ''); // Clear the VIN field
                return;
            }
        }
    }

    return (
        <div >
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 4px 12px",
            }}>
                <div>
                    <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
                        {params.title}
                    </div>
                    <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
                        Fill in the VIN-wise opening details below.
                    </div>
                </div>
            </div>
            <Formik id="vinWiseOpeningForm" size="large" width={5}
                initialValues={vinWiseOpening}
                validationSchema={vinWiseOpeningSchema}
                onSubmit={(values, { resetForm }) => saveVinWiseOpening(values, resetForm)}
                render={({ handleSubmit, resetForm, onChange, values, handleChange, setFieldValue, setFieldError, errors, touched }) => (
                    <Form as={FormikForm} size="small" className="CustomeForm" width={5} onSubmit={handleSubmit}>
                        <Form.Group widths={4} style={{ paddingBottom: "7px" }}>
                            <Field name="parent_group" label="Parent Group" component={FormikInputComponent} placeholder="PARENT GROUP" isMandatory={true}></Field>
                            <Field
                                name="vin"
                                label="VIN"
                                component={FormikInputComponent}
                                placeholder="VIN"
                                readOnly={props.match.path === '/vin_wise_opp/edit/:id' ? true : false}
                                className={props.match.path === '/vin_wise_opp/edit/:id' ? 'readOnly' : ''}
                                onBlurFunc={checkVinExists}
                                isMandatory={true}
                            ></Field>
                            <Field name="cost" label="Cost" component={FormikInputComponent} placeholder="Cost" isMandatory={true}></Field>
                        </Form.Group>
                        <Button type="submit" size="medium" color="blue" className="CustomeBTN"> {params.submitButtonText} </Button>
                        {savedVinWiseOpeningId ?
                            <Notification id={savedVinWiseOpeningId} resetForm={resetForm} notifySelector={getNotification} notifyDoneAction={setNotifyDone} type='save' />
                            :
                            null}
                    </Form>
                )}
            />
        </div>
    )
}

export default VinWiseOpeningForm;